module.exports = __webpack_public_path__ + "img/logo.e7da3500.png";